// Client-side distress keyword pre-check for free text that never reaches the
// server (spec §6.4: every free-text input is screened). The text itself is
// never sent anywhere; a match only routes the visitor to support.
//
// KEEP IN SYNC with ClaryNext-BE utils/start/safety.js (PATTERNS) and its tests.
const APOS = "['’]";

const PATTERNS: RegExp[] = [
  // en
  /\b(kill|hurt|harm)\s+myself\b/i,
  /\b(end|take)\s+my\s+(own\s+)?life\b/i,
  /\bwant\s+to\s+die\b/i,
  /\bsuicid/i,
  /\bno\s+reason\s+to\s+(live|go\s+on|keep\s+going)\b/i,
  /\bend\s+it\s+all\b/i,
  new RegExp(`\\b(don${APOS}?t|do\\s+not)\\s+want\\s+to\\s+(live|be\\s+alive)\\b(?!\\s+(in|with|at|near|there|here|on|by|alone|together|abroad)\\b)`, "i"),
  new RegExp(`\\b(don${APOS}?t|do\\s+not)\\s+want\\s+to\\s+be\\s+here\\s+any\\s*more\\b`, "i"),
  /\bbetter\s+off\s+dead\b/i,
  /\b(please|just|someone|somebody|god)\s+(just\s+|please\s+)?kill\s+me\b/i,
  /(^|[.!?\n]\s*)kill\s+me\b/i,
  /\bkill\s+me\s+now\b/i,
  // he (no \b: it is ASCII-only)
  /רוצה\s+למות/,
  /לפגוע\s+בעצמי/,
  /להתאבד/,
  /לשים\s+קץ\s+ל(חיי|חיים\s+שלי)/,
  /אין\s+טעם\s+לחיות/,
  /נמאס\s+לי\s+לחיות/,
  /לא\s+רוצה\s+לחיות/,
  // de
  /\bmich\s+umbringen\b/i,
  /\bnicht\s+mehr\s+leben\b/i,
  /\bsuizid/i,
  /\bich\s+will\s+sterben\b/i,
  /\bich\s+bringe?\s+mich\s+um\b/i,
  /\bnicht\s+mehr\s+da\s+sein\b/i,
];

export function precheckDistress(text: string | null | undefined): boolean {
  const t = String(text || "");
  return !!t.trim() && PATTERNS.some((re) => re.test(t));
}
